import React, { useEffect, useState, useRef } from "react";
import "./App.css";
import { ReactTagManager } from "react-gtm-ts";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

function App() {
  ReactTagManager.init(tagManagerArgs);
  const intercomInitialized = useRef(false);
  const BASE_URL = "https://wix.certifiedcode.io/ecwid-backtotop";
  const [instance, setInstance] = React.useState({} as any);
  const [isEnabled, setIsEnabled] = useState(false);

  useEffect(() => {
    if (!intercomInitialized.current && instance.intercomToken && instance.storeProfile && instance.app) {
      const name = instance.storeProfile.account.accountName;
      const registrationDate = new Date(
        instance.storeProfile.account.registrationDate
      );
      const created_at = Math.floor(registrationDate.getTime() / 1000);
      const phone = instance.storeProfile.company.phone;
      const email = instance.storeProfile.account.accountEmail;
      const utm_source = instance.app.client_id;
      const options = {
        email,
        name,
        created_at,
        phone,
        user_hash: instance.intercomToken,
        utm_source,
      };
      window.Intercom("boot", options);
      intercomInitialized.current = true;
    }
  }, [instance]);

  useEffect(() => {
    try {
      window.EcwidApp.init({
        app_id: "back-to-top",
        autoloadedflag: true,
        autoheight: false,
      });

      getInstance();
      
      const updateHeight = () => {
        var body = document.body,
          html = document.documentElement;

        var height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        );

        window.EcwidApp.setSize({ height: height });
      };

      updateHeight();

      const instanceIntervalId = setInterval(getInstance, 10000);
      const heightIntervalId = setInterval(updateHeight, 1000);

      if (instance) {
        getSettings();
      }

      return () => {
        clearInterval(instanceIntervalId);
        clearInterval(heightIntervalId);
      };
    } catch (error) {
      console.error(error);
    }
  }, []);

  function getInstance() {
    fetch(
      BASE_URL + "/_functions/@certifiedcode/ecwid-repluggable-backend/auth",
      {
        headers: {
          Authorization: new URLSearchParams(window.location.search).get(
            "payload"
          )!,
        },
      }
    )
      .then((response) => response.json())
      .then((payload) => {
        setInstance(payload);
        window.EcwidApp.ready();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function getSettings() {
    fetch(BASE_URL + "/_functions/@certifiedcode/ecwid-repluggable-backend/settings", {
      method: "GET",
      headers: {
        Authorization: new URLSearchParams(window.location.search).get(
          "payload"
        )!,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setIsEnabled(data.isEnabled);
      })
      .catch(() => {});
  }

  function setSettings() {
    fetch(BASE_URL + "/_functions/@certifiedcode/ecwid-repluggable-backend/settings", {
      method: "POST",
      headers: {
        Authorization: new URLSearchParams(window.location.search).get(
          "payload"
        )!,
      },
      body: JSON.stringify({
        isEnabled: !isEnabled,
        config: {}
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setIsEnabled(data.isEnabled);
      })
      .catch(() => {});
  }

  const handleToggle = () => {
    if (!instance?.subscription) {
      window.open(
        instance?.storeProfile
          ? encodeURI(
              "https://www.certifiedcode.us/upgrade/apps?checkout=" +
                JSON.stringify({
                  settings: {
                    allowLogout: false,
                    allowDiscountRemoval: false,
                  },
                  items: [{ priceId: "pri_01jm9kfa7bbqgd4smscnbhm6mt", quantity: 1 }],
                  customer: {
                    email: instance.storeProfile.account.accountEmail,
                    business: { name: instance.storeProfile.account.accountName },
                    address: {
                      countryCode: instance.storeProfile.company.countryCode,
                      postalCode: instance.storeProfile.company.postalCode,
                      city: instance.storeProfile.company.city,
                    },
                  },
                  customData: { store_id: `${instance.store_id}` },
                })
            )
          : undefined,
        "_blank"
      );
    } else {
      setSettings();
    }
  };

  return (
    <div className="settings-page cf">
      <div className="settings-page__header">
        <div className="settings-page__titles settings-page__titles--left">
          <h1 className="settings-page__title">Back to Top Button</h1>
          <div className="settings-page__subtitle">Add a sleek scroll-to-top button with progress indicator</div>
        </div>

        <div className="named-area">
          <div className="named-area__header">
            <div className="named-area__titles">
              <div className="named-area__title">Back to Top Overview</div>
            </div>
            <div className="named-area__description">
              Enhance your store's navigation with a stylish back-to-top button. Plans start from $10.00/month.
            </div>
          </div>
          <div className="named-area__body">
            <div className="a-card a-card--normal" style={{ backgroundColor: '#2964de' }}>
              <div className="a-card__paddings">
                <div className="upgrade-element upgrade-element--inverted">
                  <div className="upgrade-element__core">
                    <div className="upgrade-element__data">
                      <div className="upgrade-element__title">Improve Your Store Navigation</div>
                      <div className="upgrade-element__content">
                        <div className="upgrade-element__text">
                          Help your customers navigate long pages effortlessly with a smart back-to-top button featuring a scroll progress indicator.
                        </div>
                        <div className="upgrade-element__action">
                          {instance.store_id ? (
                            <div className="status-block__primary-action">
                              <label className="checkbox big">
                                <input 
                                  type="checkbox" 
                                  checked={isEnabled}
                                  onChange={handleToggle}
                                />
                                <div>
                                  <div></div>
                                </div>
                              </label>
                            </div>
                          ) : (
                            <div className="loader"></div>
                          )}
                        </div>
                      </div>
                      <div className="upgrade-element__note">
                        <div>{instance?.subscription ? 'Click to toggle back to top button' : 'Upgrade to enable back to top button'}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="named-area">
          <div className="named-area__header">
            <div className="named-area__titles">
              <div className="named-area__title">Key Features</div>
            </div>
            <div className="named-area__description">
              Discover how our back to top button can enhance your store's user experience
            </div>
          </div>
          <div className="named-area__body">
            <div className="a-card a-card--normal">
              <div className="a-card__paddings">
                <div>
                  <div className="promo-row">
                    <div className="promo-row__content">
                      <ul className="titled-items-list">
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">Circular Progress Indicator</div>
                          <div className="titled-item__content">
                            Visual feedback showing how far users have scrolled down the page
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">Smart Positioning</div>
                          <div className="titled-item__content">
                            Automatically appears in the bottom right corner when needed
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">Smooth Animation</div>
                          <div className="titled-item__content">
                            Elegant scrolling animation for a better user experience
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="named-area__footer">
            <div className="named-area__footer-description"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
